import React from "react";
import { Link } from "react-router-dom";

interface AuthLayoutProps {
  children: React.ReactNode;
  showLogo?: boolean;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  showLogo = true,
}) => {
  const isTabletOrMobile = window.innerWidth < 1024;

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-black">
      {/* Left Section (100% on mobile/tablet, 40% on desktop) */}
      <div className="w-full lg:w-[40%] flex flex-col justify-center bg-white order-1 h-screen overflow-y-auto relative">
        <div className="w-full max-w-[440px] mx-auto px-4 md:px-8">
          {/* Logo */}
          {showLogo && (
            <div className="mb-8">
              <Link to="/" className="inline-block">
                <img
                  src="/fullLogo.png"
                  alt="OSMOAIR Logo"
                  className="h-8 md:h-10"
                />
              </Link>
            </div>
          )}

          {/* Content */}
          {children}
        </div>
      </div>

      {/* Right Section with image (60%) */}
      {!isTabletOrMobile && (
        <div className="hidden lg:flex lg:w-[60%] order-2 fixed right-0 h-screen overflow-hidden bg-black">
          <img
            src="/images/2ff9992e-07df-405e-a962-510df7436e2d.png"
            alt="Sensor Visualization"
            className="object-cover w-full h-full"
          />
        </div>
      )}
    </div>
  );
};

export default AuthLayout;
